import { Avatar, Divider, Grid, IconButton, Menu } from '@mui/material';

import strings, { url } from 'constants/index';
import { themeCI, themePROD, themeUAT } from 'theme';

import { headerStyles } from './Header.styles';

export const HeaderEnvMenu = ({ envEl, handleClose }) => (
  <Menu
    id="env-menu"
    anchorEl={envEl}
    keepMounted
    open={Boolean(envEl)}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    MenuListProps={{
      className: 'nonPaddedContent',
    }}
  >
    <Grid sx={headerStyles.envMenu}>
      <IconButton
        sx={headerStyles.envButton}
        disableRipple
        onClick={() => {
          window.location.href = url.prod;
        }}
        size="large"
      >
        <Avatar sx={{ backgroundColor: themePROD.palette.primary.main, color: 'white' }}>{strings.prod}</Avatar>
      </IconButton>
      <Divider sx={headerStyles.envDivider} />
      <IconButton
        sx={headerStyles.envButton}
        disableRipple
        onClick={() => {
          window.location.href = url.uat;
        }}
        size="large"
      >
        <Avatar sx={{ backgroundColor: themeUAT.palette.primary.main, color: 'white' }}>{strings.uat}</Avatar>
      </IconButton>
      <Divider sx={headerStyles.envDivider} />
      <IconButton
        sx={headerStyles.envButton}
        disableRipple
        onClick={() => {
          window.location.href = url.ci;
        }}
        size="large"
      >
        <Avatar sx={{ backgroundColor: themeCI.palette.primary.main, color: 'white' }}>{strings.ci}</Avatar>
      </IconButton>
    </Grid>
  </Menu>
);
